function initCallbackForms() {
  const forms = document.querySelectorAll('.callback__form');
  if (!forms.length) return;

  forms.forEach(form => {
    const submitButton = form.querySelector('button[type="submit"]');
    const personalData = form.querySelector('.callback-personal-data');
    const thankYouBlock = form.querySelector('.thank-you');

    let isSubmitting = false;
    let resetTimer = null;

    function setInitialState() {
      if (submitButton) {
        submitButton.style.display = '';
        submitButton.style.opacity = '1';
        submitButton.style.transform = 'translateY(0)';
        submitButton.disabled = false;
        submitButton.classList.remove('is-loading');
      }

      if (personalData) {
        personalData.style.display = '';
        personalData.style.opacity = '1';
        personalData.style.transform = 'translateY(0)';
      }

      if (thankYouBlock) {
        thankYouBlock.style.display = 'none';
        thankYouBlock.style.opacity = '0';
        thankYouBlock.style.transform = 'translateY(-2rem)';
      }
    }

    function setSuccessState() {
      if (submitButton) {
        submitButton.style.opacity = '0';
        submitButton.style.transform = 'translateY(-2rem)';
        setTimeout(() => {
          submitButton.style.display = 'none';
        }, 400);
      }

      if (personalData) {
        personalData.style.opacity = '0';
        personalData.style.transform = 'translateY(-2rem)';
        setTimeout(() => {
          personalData.style.display = 'none';
        }, 400);
      }

      if (thankYouBlock) {
        thankYouBlock.style.display = 'block';
        thankYouBlock.style.opacity = '1';
        thankYouBlock.style.transform = 'translateY(0)';
      }
    }

    function resetFormFields() {
      form.reset();

      form.querySelectorAll('input, textarea, select').forEach(field => {
        if (field.type === 'hidden') return;

        if (field.type === 'checkbox' || field.type === 'radio') {
          field.checked = field.defaultChecked;
          return;
        }

        if (field.tagName === 'SELECT') {
          field.selectedIndex = 0;
          return;
        }

        if (field.type === 'file') {
          field.value = '';
          return;
        }

        field.value = '';
      });
    }

    form.addEventListener('submit', async function(event) {
      event.preventDefault();

      if (isSubmitting) return;
      isSubmitting = true;

      if (resetTimer) {
        clearTimeout(resetTimer);
      }

      if (submitButton) {
        submitButton.disabled = true;
        submitButton.classList.add('is-loading');
      }

      const formData = new FormData(form);
      formData.append('action', 'handle_callback_form');

      try {
        const response = await fetch(ajax_object.ajaxurl, {
            method: 'POST',
            body: formData
        });

        const result = await response.text();
        console.log(result);

        if (response.ok) {
          setSuccessState();

          resetTimer = setTimeout(() => {
            resetFormFields();
            setInitialState();
          }, 3500);
        } else {
          console.error('Ошибка ответа сервера:', result);
          setInitialState();
        }
      } catch (error) {
        console.error('Ошибка при отправке формы:', error);
        setInitialState();
      } finally {
        isSubmitting = false;
      }
    });

    setInitialState();
  });
}

document.addEventListener('DOMContentLoaded', function () {
  initCallbackForms();
});